import React from 'react'

export default function NFTS(props){
    return (
        <div className='nfts'> <img src={props.imageSource}/></div>
    )
}